import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Directive, ElementRef, forwardRef, HostBinding, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { CustomizeStringsService } from '../services/customize-strings.service';
import { TextTransformService } from '../services/text-transform.service';

const TextTransform_INPUT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TextTransformInputDirective),
  multi: true,
};

@Directive({
  selector: 'input[appTextTransform]',
  // host: { // FIXME build
  //   // When the user updates the input
  //   '(input)': 'onInput($event.target.value)',
  //   '(blur)': 'onTouched()',
  // },
  providers: [
    TextTransform_INPUT_CONTROL_VALUE_ACCESSOR,
  ],
})
export class TextTransformInputDirective extends DefaultValueAccessor implements OnInit {

  @Input('config') config;

  @HostBinding('style.text-transform') style;

  @HostListener('blur', ['$event.target.value'])
  ngOnChange(val: string) {
    let result = this.transformValue(val);

    result = result && typeof result === 'string' ? result.trim() : result;
    this.writeValue(result);
    this.onChange(result);
  };

  @HostListener('keyup', ['$event.target.value'])
  keyupChange(val: string) {
    let result = this.transformValue(val);
    this.writeValue(result);
    this.onChange(result);
  };

  public ngOnInit(): void {
    if (this.config && this.config.textTransform.type === 'capitalize') {
      this.style = 'capitalize';
    }
  }

  constructor(renderer: Renderer2, elementRef: ElementRef) {
    super(renderer, elementRef, false);
  }

  writeValue(value: any): void {
    const transformed = this.transformValue(value);
    super.writeValue(transformed);
  }

  onInput(value: any): void {
    const transformed = this.transformValue(value);

    super.writeValue(transformed);
    this.onChange(transformed);
  }

  private transformValue(value: any): any {
    let result = value;
    if (this.config && value && typeof value === 'string') {
      result = this.applyTextTransform(value);
    }
    return result;
  }

  private applyTextTransform(value: string): string {
    if (this.config.textTransform.type === 'uppercase') {
      return value.toUpperCase();
    } else if (this.config.textTransform.type === 'lowercase') {
      return value.toLowerCase();
    } else if (this.config.textTransform.type === 'capitalize') {
      return CustomizeStringsService.capitalizeFirstLetter(value);
    } else if (this.config.textTransform.type === 'capitalizeAndRemoveSpaces') {
      return CustomizeStringsService.uppercaseAndRemoveSpaces(CustomizeStringsService.capitalizeFirstLetter(value));
    } else if (this.config.textTransform.type === 'uppercaseAndRemoveSpaces') {
      return CustomizeStringsService.uppercaseAndRemoveSpaces(value.toUpperCase());
    } else if (this.config.textTransform.type === 'separate' || this.config.textTransform.type === 'separateAndConvertToNumber') {
      if (!this.config.textTransform.separatorConfig) {
        console.error('Configuration to separate textTransform is not defined! Please define config object.')
      } else {
        if (this.config.textTransform.type === 'separateAndConvertToNumber' || this.config.textTransform.type === 'amount') {
          value = CustomizeStringsService.removeNonDigitCharacters(value);
          value = CustomizeStringsService.removeLeadingZero(value);
        }
        return TextTransformService.separateValues(value, this.config.textTransform.separatorConfig);
      }
    } else {
      return value;
    }
  }

}
